export const ACTIVITY_COLORS = {
  construction: '#f59e0b',
  country: '#38bdf8',
  military: '#ef4444',
}

export const activityGeoJSON = (rows) => ({
  type: 'FeatureCollection',
  features: (rows || []).map((row) => ({
    type: 'Feature',
    geometry: { type: 'Point', coordinates: [row.lon, row.lat] },
    properties: { ...row },
  })),
})
